import React from "react";
import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-80px" }}
            transition={{ duration: 0.9, ease: easeOut, delay }}
        >
            {children}
        </motion.div>
    );
}

// Masked line-by-line reveal (for hero headlines)
export function MaskLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block"
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, ease: easeOut, delay }}
            >
                {children}
            </motion.span>
        </span>
    );
}

// Staggered container + item
export function Stagger({ children, className = "", stagger = 0.12, delay = 0 }) {
    return (
        <motion.div
            className={className}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            variants={{
                hidden: {},
                show: { transition: { staggerChildren: stagger, delayChildren: delay } },
            }}
        >
            {children}
        </motion.div>
    );
}

export const staggerItem = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: easeOut } },
};
